const Footer = ({onOpenTerms}) => (
    <footer className="bg-[#1B5125] text-white py-8 px-4">
        <div className="max-w-7xl mx-auto text-center md:flex md:justify-between md:items-center">
            <p className="mb-4 md:mb-0 text-sm text-white">
                &copy; {new Date().getFullYear()} Kancelaria Adwokacka Adwokat Olga Fedyszyn-Olszewska. Wszelkie prawa zastrzeżone.
            </p>

            <button
                onClick={onOpenTerms}
                className="text-sm text-white hover:opacity-75 transition-opacity duration-300"
            >
                Regulamin serwisu
            </button>

            <div className="flex flex-col md:flex-row md:space-x-8 text-sm">
                <div className="mb-2 md:mb-0 text-white font-semibold">
                    Adres: <span className="font-normal text-white">al. Kościuszki 93 lok. 14, 90-436 Łódź</span>
                </div>
                <div>
                    Email:
                    <a href="mailto:kancelaria@fedyszyn-olszewska.pl" className="hover:text-white font-semibold transition-colors duration-300 ml-1">
                        kancelaria@fedyszyn-olszewska.pl
                    </a>
                </div>
            </div>
        </div>
    </footer>
);

export default Footer;
